import _ from "lodash";

// messages
export const EMPTY_REQUIRED_FIELD_MESSAGE = "This is a required field.";
export const INVALID_EMAIL_MESSAGE =
  "That doesn't seem right, please enter a valid email.";
export const AGREE_TERMS_AND_CONDITIONS =
  "You need to agree to the terms of usage and privacy policy to be able to proceed further.";
export const INVALID_PASSWORD_MESSAGE =
  "The password should contain at least one lowercase letter, one uppercase letter, one number and at least 8 characters.";
export const COMPANY_NAME_EXCEED_LIMIT_MESSAGE =
  "Company Name should not exceed the limit of more than 100 characters.";
export const WEBHOOK_NAME_EXCEED_LIMIT_MESSAGE =
  "The webhook name can be maximum 100 characters long.";

export const REMOVE_TEXT = "Remove";
export const REMOVE_MODAL_TITLE = "Remove account?";
export const REMOVE_MODAL_BUTTON_TITLE = "Remove account";
export const REMOVE_MODAL_MESSAGE =
  "Are you sure you want to remove the following account?";
export const REMOVE_MODAL_WARNING_MESSAGE =
  "Removing the account means losing all data. Ask the account creator to reconnect in order to regain data access";

export const CONNECTED_TOOLTIP_MESSAGE =
  "The account connection is live. All good here.";
export const EXPIRED_TOOLTIP_MESSAGE_1 =
  "The connection to this account has expired.";
export const EXPIRED_TOOLTIP_MESSAGE_2 =
  "Ask the account creator to reconnect in order to regain data access.";
export const DISCONNECTED_TOOLTIP_MESSAGE_1 =
  "This account has been disconnected by the creator.";
export const DISCONNECTED_TOOLTIP_MESSAGE_2 =
  "Ask the account creator to reconnect in order to regain data access.";
export const REMOVED_TOOLTIP_MESSAGE_1 = "This account has been removed.";
export const REMOVED_TOOLTIP_MESSAGE_2 =
  "Ask the account creator to reconnect in order to regain data access.";

export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const HTTPS_REGEX = /^https:\/\//;
// export const LOCALHOST_REGEX = /^^http(s)?:\/\/localhost/;
export const LOCALHOST_REGEX = /^https:\/\/localhost:/;
// /^https?:\/\/(localhost:([0-9]+\.)+[a-zA-Z0-9]{1,6})?$/;
// export const LOCALHOST_REGEX = /^http(s)?:\/\/localhost/;
//   /^https:\/\/localhost:[0-9]{1,5}\/([-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/;

export const URL_REGEX =
  /^(http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
export const IP_REGEX =
  /^https:\/\/(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)[0-9a-zA-Z\/:]*$/;
// export const IP_REGEX =
//   /^https:\/\/(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)[0-9a-zA-Z\/:]*$/;

export const NUMBER_CHECK_REGEX = /[0-9]+/; // checks if at least one number exists
export const UPPER_LETTER_CHECK_REGEX = /[A-Z]+/; // checks if at least one capital letter exist
export const LOWER_LETTER_CHECK_REGEX = /[a-z]+/; // checks if at least one lower letter exist

export const products = [
  "Identity",
  "Audience demographics",
  "Engagement",
  "Comments",
  "Income",
];
export const sandboxProducts = [
  "Identity",
  "Audience demographics",
  "Engagement",
  "Comments",
  "Income",
  "Activity contents",
];

export const WORKPLATFROMPRODUCTMAPPING = {
  "identity.is_supported": "Identity",
  "engagement.is_supported": "Engagement",
  "identity.audience.is_supported": "Audience demographics",
  "engagement.audience.is_supported": "Comments",
  "income.is_supported": "Income",
  "activity.is_supported": "Activity contents",
};

export const WORKPLATFROMIDMAPPING = {
  "9bb8913b-ddd9-430b-a66a-d74d846e6c66": {
    platformName: "Instagram",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_instagram.png",
  },
  "de55aeec-0dc8-4119-bf90-16b3d1f0c987": {
    platformName: "Tiktok",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_tiktok.png",
  },
  "14d9ddf5-51c6-415e-bde6-f8ed36ad7054": {
    platformName: "Youtube",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_youtube.png",
  },
  "7645460a-96e0-4192-a3ce-a1fc30641f72": {
    platformName: "Twitter",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_twitter.png",
  },
  "e4de6c01-5b78-4fc0-a651-24f44134457b": {
    platformName: "Twitch",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_twitch.png",
  },
  "ad2fec62-2987-40a0-89fb-23485972598c": {
    platformName: "Facebook",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_facebook.png",
  },
  "fbf76083-710b-439a-8b8c-956f607ef2c1": {
    platformName: "Substack",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_substack.png",
  },
  "fb7cafcf-60ed-468a-ad6d-6bb6899d0871": {
    platformName: "Instagram Lite",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_instagram_lite.png",
  },
  "3e6f4cdd-2119-4125-aa0d-86eee4e20fcc": {
    platformName: "AdSense",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_adsense.png",
  },
  "36410629-f907-43ba-aa0d-434ca9c0501a": {
    platformName: "LinkedIn",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_linkedin.png",
  },
  "1db0b86c-a547-4119-9834-da927171a685": {
    platformName: "Spotify",
    platformLogo:
      "https://cdn.getphyllo.com/platforms_logo/logos/logo_spotify.png",
  },
};

export const SUPPORTED_PLATFORMS = [
  "ad2fec62-2987-40a0-89fb-23485972598c", // FACEBOOK
  "9bb8913b-ddd9-430b-a66a-d74d846e6c66", // INSTAGRAM
  "de55aeec-0dc8-4119-bf90-16b3d1f0c987", // TIKTOK
  "e4de6c01-5b78-4fc0-a651-24f44134457b", // TWITCH
  "7645460a-96e0-4192-a3ce-a1fc30641f72", // TWITTER
  "14d9ddf5-51c6-415e-bde6-f8ed36ad7054", // YOUTUBE
];

export const FAILEDREASONMAPPING = {
  FAILED: {
    title: "Failed",
    reason: "Account type or permissions issue",
    toolTipText:
      "<div>Account type issue - User connected an inactive or private account. Or they did not select the correct page / channel. <br><br>Permissions issue - User did not provide all the required permissions.<div>",
  },
  CANCELLED: {
    title: "Failed",
    reason: "Abandoned",
    toolTipText:
      "The user chose not to connect the account OR did not connect in time.",
  },
  EXPIRED: {
    title: "Failed",
    reason: "Abandoned",
    toolTipText:
      "The user chose not to connect the account OR did not connect in time.",
  },
  SUCCESS: {
    title: "Success",
    reason: "",
    toolTipText: "",
  },
};

export const envBaseURLMapping = {
  sandbox: process.env.REACT_APP_SDK_API_ENDPOINT,
  staging: process.env.REACT_APP_SDK_API_STAGING_ENDPOINT,
  production: process.env.REACT_APP_SDK_API_PRODUCTION_ENDPOINT,
};

export const PHYLLO_SDK_DONE_CLICKED = "DONE_CLICKED";

export const DOMAIN_NOT_HTTPS = 'The URL should have "https" scheme.';
export const NOT_A_VALID_DOMAIN =
  "The domain of the URL should be a domain name.";
export const Sandbox = "sandbox";
export const Staging = "staging";
export const Production = "production";
export const SUBMITTED = "SUBMITTED";
export const getPageTitle = (key, environment) => {
  environment = _.startCase(environment);
  const pageTitle = {
    LOGIN_PAGE: "Sign-in — Phyllo",
    REGISTRATION_PAGE: "Registration — Phyllo",
    GETTING_STARTED_PAGE: "Getting Started — Phyllo",
    API_CREDENTIAL_PAGE: "API Credentials — Phyllo [" + environment + "]",
    WEBHOOK_PAGE: "Webhooks — Phyllo [" + environment + "]",
    WEBHOOK_CREATION_PAGE: "Create New Webhook — Phyllo [" + environment + "]",
    WEBHOOK_UPDATE_PAGE: "Edit Webhook — Phyllo [" + environment + "]",
    HELP_PAGE: "Help — Phyllo [" + environment + "]",
    SET_NEW_PASSWORD_PAGE: "Set New Password — Phyllo",
    PASSWORD_RESET_VERIFICATION: "Password Reset Verification — Phyllo",
    RESET_PASSWORD_PAGE: "Reset Password — Phyllo",
    EMAIL_VERIFICATION_PAGE: "Email Verification — Phyllo",
    CREATOR_INVITATION_PAGE: "Your Creators — Phyllo",
    CREATOR_PROFILE_PAGE: "Creator Profile — Phyllo",
  };
  return pageTitle[key];
};

export const PHYLLO_USERS_API_TIMEOUT = 40000;
export const PHYLLO_USERS_POLLING_INTERVAL = 1500;
export const GETTING_STARTED_AUTO_SCROLLING_TIMEOUT = 0;
export const GETTING_STARTED_STEP_1_CHANGE_INTERVAL = 5000;
export const GETTING_STARTED_STEP_2_CHANGE_INTERVAL = 3800;
export const GETTING_STARTED_API_RESPONSE_INTERVAL = 4000;

export const CALENDLY_MEETING_SCHEDULED_EVENT = "calendly.event_scheduled";

export const Creators = "Creators";
export const Developers = "Developers";
export const CONNECTED = "CONNECTED";

export const TabValues = {
  all: "All",
  connectedAccounts: "Connected accounts",
};

export const statusContentMapping = {
  ACTIVE: { label: "Active", color: "success" },
  ACTION_NEEDED: { label: "Action needed", color: "error" },
  INVITED: { label: "Invite sent", color: "default" },
};

export const DisconnectionSource = {
  DEVELOPER_API: "DEVELOPER_API",
  INTERNAL_API: "INTERNAL_API",
};

/**
 * Enum-like object for account status. Not a 1:1 mapping with backend, but useful for frontend
 * @type {{NOT_CONNECTED: {label: string, key: string}, SESSION_EXPIRED: {label: string, key: string}, CONNECTED: {label: string, key: string}, REMOVED: {label: string, key: string}}}
 */
export const AccountStatus = {
  CONNECTED: { key: "CONNECTED", label: "Connected" },
  NOT_CONNECTED: { key: "NOT_CONNECTED", label: "Disconnected" },
  SESSION_EXPIRED: { key: "SESSION_EXPIRED", label: "Session expired" },
  REMOVED: { key: "REMOVED", label: "Removed" },
};

export const failedReasons = ["NOT_CONNECTED", "SESSION_EXPIRED"];

export const failedReasonsTooltipContentMapping = {
  NOT_CONNECTED: "Disconnected",
  SESSION_EXPIRED: "Session expired",
};

export const RECORDS_PER_PAGE = 10;
export const DEBOUNCE_TIME = 800;

export const WIDTH_CONTENT_CARD = 283;
export const GAP_BETWEEN_CONTENT_CARDS = 8;
export const CONTENTS_PER_PAGE = 8;

export const MEETING_SCHEDULE_LINK =
  "https://www.getphyllo.com/talk-to-us-phyllo";

export const SCREEN_HEIGHT_FOR_LARGE_SCREEN = 900;
export const YOFFSET_FOR_LARGE_SCREEN = 1000;
export const YOFFSET_FOR_SMALL_SCREEN = 350;

// tenant ids for which the creator module is enabled

export const creatorModuleSpecificTenantIDs = [
  "2305bee3-fdc9-4983-ae59-5bdb959ddd39", // developer tenant
  "0cea46f0-e575-410c-ae5b-30108c5dfd93", // developer tenant
  "6984faf2-d7ac-4dc0-8dbb-d65742639fa1", // developer tenant
  "5c43f51a-6a11-4c65-8bf6-2e84100671f1", // developer tenant
  "09abfc3f-234a-4989-922d-6708a7377e1e", // developer tenant
  "cd04e0e0-16da-4dad-b528-cf60cb638875", // phyl@getphyllo.com production
  "2d39eed8-e072-44ab-97ca-de59515c2679", // pranav+3335@getphyllo.com production,
  "890a8666-3ac1-4be1-ba40-9fccc938f534", // pranav+3333@getphyllo.com pre-prod
  "0be1718f-a922-4464-bbd6-75a68f3d89c6", // phyllo@456growth.com production
  "ea99e4ac-9a57-4568-ae05-513feb10f9ac", // Seed Marketing Agency production"
];

export const creatorModuleProductID = "ebc2e177-45d4-4a30-b3a9-0844d75350fa";

export const connectionsStatus = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};
export const CREATOR_COLUMNS = {
  NAME: "Name",
  EMAIL: "Email",
  STATUS: "Status",
  PLATFORM: "Platform",
  INVITED_ON: "Invited on",
  CONNECTED_ON: "Connected on",
  USERNAME: "Username",
  ACTIONS: "Actions",
};
export const FROM_DATE = "From date";
export const TO_DATE = "To date";
export const export_profile = "Export profile";
export const last_updated = "Last updated";

export const SOMETHING_WRONG_ERROR = {
  title: "Something is wrong on our end.",
  message: "Please try again in some time.",
};

export const Connection_attempts = "Connection attempts";
export const clickSortMsg = "Click to sort";

export const sort_by_keys = {
  created_at: { key: "created_at", fieldName: "Attempted at" },
  work_platform_id: { key: "work_platform_id", fieldName: "Platform" },
};

export const APPLY = "Apply";
export const RESET = "Reset";
export const DATE_FORMAT = "MMM DD, YYYY";
export const DATE_TIME_FORMAT = "MMM DD, YYYY [at] hh:mm A";
export const ACCOUNT_STATUS = "Account status";
